/*
 * WorkAndBuhin.vue の車両表示項目とおすすめ・純正部品利用可否表示を切り出した処理。
 */
export interface VehicleDisplayState {
  katashikiShiteiNo: string;
  ruibetsuKubunNo: string;
  fTireSizeInput: any;
  rTireSizeInput: any;
  shadaiNo: string;
}

export interface WorkBuhinAvailabilityState {
  hideNisseirenJunsei: boolean;
  isUseJunseiBuhin: boolean;
}

/*
 * resolveKatashikiShiteiNo を WorkAndBuhin.vue から分離し、
 * 車両表示値 を親側置換や単体テストで固定するため。
 */
export function resolveKatashikiShiteiNo(carSelection: any): string {
  if (carSelection && carSelection.katashikiShiteiNo) {
    return carSelection.katashikiShiteiNo;
  }
  return "";
}

/*
 * resolveRuibetsuKubunNo を WorkAndBuhin.vue から分離し、
 * 車両表示値 を親側置換や単体テストで固定するため。
 */
export function resolveRuibetsuKubunNo(carSelection: any): string {
  if (carSelection && carSelection.ruibetsuKubunNo) {
    return carSelection.ruibetsuKubunNo;
  }
  return "";
}

/*
 * resolveFTireSizeInput を WorkAndBuhin.vue から分離し、
 * 車両表示値 を親側置換や単体テストで固定するため。
 */
export function resolveFTireSizeInput(carSelection: any): any {
  return carSelection ? carSelection.fTireSizeInput : undefined;
}

/*
 * resolveRTireSizeInput を WorkAndBuhin.vue から分離し、
 * 車両表示値 を親側置換や単体テストで固定するため。
 */
export function resolveRTireSizeInput(carSelection: any): any {
  return carSelection ? carSelection.rTireSizeInput : undefined;
}

/*
 * resolveShadaiNo を WorkAndBuhin.vue から分離し、
 * 車両表示値 を親側置換や単体テストで固定するため。
 */
export function resolveShadaiNo(currentState: any): string {
  if (currentState && currentState.customerCar) {
    return currentState.customerCar.shadaiNo;
  }
  return "";
}

/*
 * buildVehicleDisplayState を WorkAndBuhin.vue から分離し、
 * 車両表示 getter で使う5項目の fallback 条件をまとめて固定するため。
 */
export function buildVehicleDisplayState(params: {
  carSelection: any;
  currentState: any;
}): VehicleDisplayState {
  return {
    katashikiShiteiNo: resolveKatashikiShiteiNo(params.carSelection),
    ruibetsuKubunNo: resolveRuibetsuKubunNo(params.carSelection),
    fTireSizeInput: resolveFTireSizeInput(params.carSelection),
    rTireSizeInput: resolveRTireSizeInput(params.carSelection),
    shadaiNo: resolveShadaiNo(params.currentState)
  };
}

/*
 * resolveIsUseJunseiBuhin を WorkAndBuhin.vue から分離し、
 * 車両表示値 を親側置換や単体テストで固定するため。
 */
export function resolveIsUseJunseiBuhin(
  isUseNisseiren: number,
  hideNisseirenJunsei: boolean
): boolean {
  return isUseNisseiren === 2 && !hideNisseirenJunsei;
}

/*
 * buildWorkBuhinAvailabilityState を WorkAndBuhin.vue から分離し、
 * 日整連・純正部品の非表示指定と機能設定から利用可否を判定する。
 */
export function buildWorkBuhinAvailabilityState(params: {
  hideNisseirenJunsei: boolean;
  isUseNisseiren: number;
}): WorkBuhinAvailabilityState {
  const hideNisseirenJunsei = params.hideNisseirenJunsei;
  return {
    hideNisseirenJunsei,
    isUseJunseiBuhin: resolveIsUseJunseiBuhin(
      params.isUseNisseiren,
      hideNisseirenJunsei
    )
  };
}
